/** Preserve word boundaries before native single-line paste sanitization. */
export function replacePgnPlayerNameLineBreaks(value: string): string {
  return value.replace(/\r\n|[\r\n]/g, " ");
}
